import Axios from "axios"

export default {
    // addZoneNote(_zoneID, _email, _notes) {
    //     return Axios.post(
    //         "/addZoneNote",
    //         {
    //             zoneID: _zoneID,
    //             email: _email,
    //             notes: _notes
    //         },
    //         {
    //             headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
    //         }
    //     )
    // },
    addZoneAlarm(_zoneID, _alarmTypeID, _name, _enabled, _threshold, _hysterisis) {
        return Axios.post(
            "/addZoneAlarm",
            {
                zoneID: _zoneID,
                alarmTypeID: _alarmTypeID,
                enabled: _enabled,
                threshold: _threshold,
                hysterisis: _hysterisis,
                name: _name
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    updateZoneAlarm(_id, _name, _enabled, _threshold, _hysterisis) {
        return Axios.post(
            "/updateZoneAlarm",
            {
                id: _id,
                enabled: _enabled,
                threshold: _threshold,
                hysterisis: _hysterisis,
                name: _name
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    deleteZoneAlarm(_zoneAlarmID) {
        return Axios.post(
            "/deleteZoneAlarm",
            {
                id: _zoneAlarmID
            },
            {
                headers: { Authorization: "Bearer " + localStorage.getItem("access_token") },
            }
        )
    },
    getZoneAlarms(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        }
        return Axios.post("/getZoneAlarms", { zoneID: _zoneID, }, config)
    },
    getZoneAlarmLog(_zoneID) {
        var config = {
            headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
        }
        return Axios.post("/getZoneAlarmLog", { zoneID: _zoneID, }, config)
    },
}



// WEBPACK FOOTER //
// ./src/api/alarms.service.js